<table infiniteScroll
  [infiniteScrollDistance]="0"
  [infiniteScrollThrottle]="500"
  [infiniteScrollDisabled]="infiniteScrollDisabled"
  (scrolled)="loadNextAlerts.emit()"
  class="table table-hover tableLatest">
  <thead>
    <tr>
      <th></th>
      <th>{{ "START_TIME" | translate }}</th>
      <th>{{ "DEVICE" | translate }}</th>
      <th>{{ "EVENT" | translate }}</th>
      <th>{{ "USER_OR_RECIPIENT" | translate }}</th>
      <th>{{ "END_TIME" | translate }}</th>
    </tr>
  </thead>

  <tbody>
    @for (alert of alerts; track alert; let e = $even; let i = $index) {
      <!-- Alert header row -->
      <tr class="trCollapse"
        [ngClass]="{ trEven: e }"
        (click)="expandRow(alert)">
        <td><span class="fa-light" [ngClass]="alert.expanded ? 'fa-minus' : 'fa-plus'"></span></td>
        <td>{{ alert.receiveTime | moment : "l LTS" }}</td>
        <td>
          {{ alert.deviceName ? alert.deviceName : alert.deviceId }}
          @if (getNfcTagForAlert(alert); as nfcTag) {
            <span> - {{ nfcTag }}</span>
            } <!-- Show NFC tag if nurse visit-->
          </td>
          <td>
            <div class="event-cell-content">
              <span class="event-name-text">{{ alert.activationGroup | getActivationName : alert.activationNode : alert.deviceType : alert.customActivationName : alert.connTimeLimit }}</span>
              @if ((alert.deviceType?.startsWith('04') || alert.deviceType?.startsWith('05') || alert.deviceType?.startsWith('31')) && alert.activationNode=='1' && alert.additionalPresses?.length > 0) {
                <div class="button-counter-badge"
                  [matTooltip]="'ADDITIONAL_PRESSES_DURING_ALERT' | translate"
                  matTooltipPosition="right">
                  <div class="press-counter-wrapper">
                    <span class="button-counter-badge_content">+{{alert.additionalPresses.length}}</span>
                  </div>
                </div>
              }
            </div>
          </td>
          <td>
            @if (!alert.cancelled) {
              <!-- Show different recipient if alarm was completed with EMA timeout. In that case resolverName is always NO_USER and deliveryType is EMA -->
              @if (shouldShowEmaTimeout(alert)) {
                <div>
                  {{ "EMA_COMPLETE_TIMEOUT" | translate }} ({{ alert.emaEvents | getResolverForTimeout}})
                </div>
              } @else {
                @if (alert.resolverName !== 'STAFF_ERROR' && alert.resolverName !== 'QR_CODE') {
                  <span>
                    <span class="fa-light fa-fw" [ngClass]="alert | getDeliveryClass"></span>
                    {{ alert.resolverName !== "NO_USER" ? alert.resolverName : (alert.deliveryType | getDeliveryStr)}}
                  </span>
                }
                @if (alert.resolverName === 'STAFF_ERROR') {
                  <span>
                    <span class="fa-light fa-fw fa-exclamation-triangle text-danger"></span>
                    {{ "DELIVERY_ERROR" | translate }}
                  </span>
                }
                @if (alert.resolverName === 'QR_CODE') {
                  <span>
                    <span class="fa-light fa-fw fa-qrcode"></span>
                    {{ "QR_CODE" | translate }}
                  </span>
                }
              }
              <!--Show normal alarm recipient-->
            }
            <!--If alarm was cancelled show special text for that-->
            @if (alert.cancelled) {
              <span class="text-danger">
                <span class="fa-light fa-fw fa-ban"></span>
                {{ "CANCELLED" | translate }}
              </span>
            }
          </td>
          <td> {{ alert.completeTime | moment : "l LTS" }}</td>
        </tr>
        <!--Alert event detail row's data-->
        @if (alert.expanded) {
          <tr [ngClass]="{ trEven: e }">
            <td colspan="6" class="tdDetails">
              <div class="rowTaskId" [ngClass]="{ rowTaskIdEven: e }">
                {{ alert.taskId }}
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div>
                    <strong>{{ "SERIAL_NUMBER" | translate}}:</strong> {{ alert.deviceId }}
                    <br />
                    @if (alert.environmentId !== '00000000') {
                      <span>
                        <strong> {{"BASESTATION" | translate}}:</strong> {{ alert.environmentName }} ({{ alert.environmentId}})
                        <br />
                      </span>
                    }
                    <strong>{{ "ALARM_ROUTE" | translate }}:</strong> {{ alert.alertRouterName }} ({{ alert.alertRouterId }})
                    <br />
                    <strong>{{ "AVAILABLE_USERS" | translate }}: </strong>
                    @if (alert.receivedBy) {
                      @if (alert.receivedBy.length > 0) {
                        @if (!alert.receivedBy[0]?.serverError) {
                          @for (user of alert.receivedBy; track user) {
                            <span>
                              <br />
                              {{ user.familyName }}, {{ user.firstName }} ({{ user.userId }})
                            </span>
                          }
                        } @else {
                          <span>{{ "NO_INFORMATION_AVAILABLE" | translate }}</span>
                        }
                      } @else {
                      }
                    } @else {
                      <span>{{ "NO_INFORMATION_AVAILABLE" | translate }}</span>
                    }
                    @if (alert.visitOnAlertStarted) {
                      <br /><br />
                      <strong>{{ "RELATED_VISIT" | translate }}:</strong>
                      <br />
                      <span
                        class="text-primary cursorPointer"
                        style="text-decoration: underline;"
                        (click)="openLinkedVisitHandler(alert); $event.stopPropagation()">
                        {{ "DIGITAL_SUPERVISION_VISIT" | translate }} - {{ alert.visitOnAlertStarted | moment : "l LTS" }}
                      </span>
                    }
                    @if (alert.pausedDevices && alert.pausedDevices.length > 0) {
                      <br /><br />
                      <strong>{{ "PAUSED_ALARMS" | translate }}: </strong>
                      @for (device of alert.pausedDevices; track device; let last = $last) {
                        <span>
                          <br />
                          {{ device.deviceName }} ({{ device.deviceID }})
                          {{
                          getActivationName(
                          device.actGroup,
                          device.actNode,
                          device.deviceID,
                          device.deviceClass
                          )
                          }}
                        </span>
                      }
                    }
                  </div>
                </div>
                @if (alert.emaEvents || alert.callEvents || alert.emailEvents || alert.details) {
                  <div class="col-md-3">
                    <!--EMA-->
                    @if (alert.emaEvents) {
                      <div>
                        @for (ema of sortedEmaEvents(alert.emaEvents); track ema) {
                          <div class="mb-2">
                            @if (ema.eventType !== 'LOG_NEW_NOTE') {
                              <div>
                                <!--Routing changed event is inside EMA events. Show different icon and header for that one-->
                                @if (ema.eventType === 'LOG_NEW_ALERT' || ema.eventType === 'LOG_ROUTING_CHANGED') {
                                  <strong>
                                    <span class="fa-light fa-lg"
                                    [ngClass]="{'fa-mobile': ema.eventType === 'LOG_NEW_ALERT', 'fa-cog': ema.eventType ==='LOG_ROUTING_CHANGED'}"></span>
                                    {{ ema.eventType === "LOG_ROUTING_CHANGED" ? ("SYSTEM" | translate) : "Everon Mobile" }}
                                  </strong>
                                }
                                @if (ema.userId !== 'NO_USER') {
                                  <div>
                                    {{ ema.userName }} ({{ ema.userId }})
                                    @if (ema.nfcId) {
                                      <span>
                                        {{ "WITH_NFC" | translate }} {{ ema.nfcName }} ({{ ema.nfcId }})
                                      </span>
                                    }
                                  </div>
                                }
                                @if (ema.eventType === 'LOG_NEW_STATE_COMPLETED' && ema.userId === 'NO_USER') {
                                  <div>
                                    {{ "EMA_COMPLETE_TIMEOUT" | translate}} ({{alert.emaEvents | getResolverForTimeout}})
                                  </div>
                                }
                                <div>
                                  {{ ema.eventType | translate}} - {{ ema.time | moment : "l LTS"}}
                                </div>
                                <div style="font-weight: bold;">
                                  {{ alert.receiveTime | calculateTime : ema.time }}
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <!-- CALL+SMS-->
                    @if (alert.callEvents && alert.callEvents.length > 0) {
                      <div>
                        <strong> <span class="fa-light fa-phone"></span> Call+SMS </strong>
                        @for (call of alert.callEvents; track call) {
                          <div class="mb-2">
                            @if (call.CallCount > 0) {
                              <div>
                                <div>
                                  {{ call.UserName }}
                                  @if (call.DialNumber) {
                                    <span>
                                      ({{ call.DialNumber }})
                                    </span>
                                  }
                                </div>
                                <div>
                                  {{ "CALL_COUNT" | translate }} {{ call.CallCount }}
                                </div>
                                <div>
                                  {{ "CALL_" + call.CallResult | removeSpaces | translate }}
                                  @if ( call.CallResult !== 'CALL FAILURE') {
                                    <span>
                                      - {{ call.LastCallTime | moment : "l LTS" }}
                                    </span>
                                  }
                                </div>
                                @if (call.CallResult !== 'CALL FAILURE') {
                                  <div style="font-weight: bold;">
                                    {{ alert.receiveTime | calculateTime : call.LastCallTime }}
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <!--EMAIL-->
                    @if (alert.emailEvents && alert.emailEvents.length > 0) {
                      <div>
                        <strong><span class="fa-light fa-envelope"></span> Email</strong>
                        @for (email of alert.emailEvents; track email) {
                          <div class="mb-2">
                            <div>
                              {{ email.UserName }} ({{ email.UserId }})
                            </div>
                            @if (email.EmailAddress) {
                              <div>
                                {{ email.EmailAddress }}
                              </div>
                            }
                            <div>
                              {{ email.DeliveringTime | moment : "l LTS" }}
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <!--Delivery error info-->
                    @if (alert.resolverName === 'STAFF_ERROR') {
                      <div>
                        <strong>
                          <span class="fa-light fa-fw fa-exclamation-triangle text-danger"></span> {{ "DELIVERY_ERROR" | translate}}
                        </strong>
                        <p>{{ "DELIVERY_ERROR_INFO" | translate }}</p>
                      </div>
                    }
                  </div>
                }
                <!-- SMS -->
                @if (alert.deliveryType?.includes('SMS')) {
                  <div class="col-md-2">
                    <strong>
                      <span class="fa-light fa-comment"></span> SMS
                    </strong>
                    @for (sms of alert?.smsEvents; track sms) {
                      <div class="mb-2">
                        <div> {{ sms.UserName }} ({{ sms.UserId }}) </div>
                        <div> {{ sms.PhoneNumber }} </div>
                        <div> {{ "MESSAGE_SENT" | translate}}: {{ sms.SendingTime | moment : "l LTS"}}</div>
                        @if ((sms.DeliveringTime | moment: 'l LTS') !== '-') {
                          <div>
                            {{ "DELIVERED" | translate }}: {{ sms.DeliveringTime | moment : "l LTS"}}
                          </div>
                        }
                      </div>
                    }
                    @if (alert?.smsEvents?.length == 0 && alert.resolverName !== 'QR_CODE') {
                      <div class="pt-1">
                        <span class="text-danger ml-2"><span class="fa-light fa-exclamation-triangle mr-1"></span> {{ "SMS_DELIVERY_ERROR" | translate }}</span>
                      </div>
                    }
                  </div>
                }
                <!--Alarm Reasons-->
                @if (alert?.alarmReasons?.length > 0) {
                  <div
                    class="col-md-3">
                    <div>
                      <strong> {{ "ALARM_REASONS" | translate}}:</strong>
                      <ul style="margin-left: -22px">
                        @for (item of alert.alarmReasons | removeAlarmReaonDuplicates; track item) {
                          <li style="right: 50px">
                            {{ (item.alarmReasonCategory | alarmCategory : alarmReasonTranslations) + " - " + (item.alarmReason | alarmReason : alarmReasonTranslations)}}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                <!-- NOTES -->
                <div class="col-md-2">
                  <strong>
                    <span class="fa-light fa-note-sticky"></span> {{ "NOTES" | translate }}
                  </strong>
                  <div class="mt-2 mb-2">
                    <span class="btn btn-outline-primary btn-sm" (click)="alert.showNoteForm = true">
                      <span class="fa-light fa-fw fa-plus"></span> {{ "ADD_NOTE" | translate }}
                    </span>
                  </div>
                  @if (alert.showNoteForm) {
                    <div class="mt-2 mb-2">
                      <div class="form-group">
                        <textarea class="form-control"
                        [(ngModel)]="alert.noteText"></textarea>
                      </div>
                      <div class="form-group">
                        <span class="btn btn-outline-primary" (click)="submitAlertNoteHandler(alert)">
                          {{ "SAVE" | translate }}
                        </span>
                        <span class="btn btn-outline-danger ml-2" (click)="alert.noteText = ''; alert.showNoteForm = false">
                          {{ "CANCEL" | translate }}
                        </span>
                      </div>
                    </div>
                  }
                  @for (comment of alert.commentEvents; track comment) {
                    <div class="mb-2">
                      <div>{{ comment.UserName }} ({{comment.UserId}})</div>
                      <div> {{ comment.CommentTime | moment : "l LTS" }}</div>
                      <app-text-format [text]="comment.Comment"></app-text-format>
                    </div>
                  }
                </div>
              </div>
              @if (alert.deliveryType!=='LOG') {
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-2">
                    <button class="btn btn-outline-primary btn-sm" (click)="openDialog(alert)">{{"DETAILED_VIEW" | translate}}</button>
                  </div>
                </div>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
